export default __webpack_public_path__ + "static/media/20200618_143337.e88a5564.jpg";